import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center mb-lg-3 mb-2" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "title mb-2" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "button-header text-lg-right upload-btn-wrap" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_8 = {
  for: "create-document-upload",
  class: "btn default-btn d-inline-block mr-2"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fas fa-cogs" }, null, -1)
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "modal-wrap default-modal" }
const _hoisted_14 = {
  class: "modal fade",
  id: "namerename",
  tabindex: "-1",
  "aria-labelledby": "namerenameLabel",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "namerenameLabel"
  }, "Rename File"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = { class: "form-group mb-0" }
const _hoisted_20 = { class: "modal-footer" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_24 = { class: "inline-items" }
const _hoisted_25 = {
  id: "foldersInMyDrive",
  class: "mr-2 mt-1"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  class: "form-group control-with-icon mb-0",
  id: "projectStatus"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_29 = { value: "active" }
const _hoisted_30 = { value: "archive" }
const _hoisted_31 = { value: "hidden" }
const _hoisted_32 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_33 = {
  key: 2,
  class: "table-loader chat-load"
}
const _hoisted_34 = {
  key: 3,
  class: "row mb-4 mx-n2"
}
const _hoisted_35 = {
  key: 4,
  class: "empty-channel bg-white p-3 mb-3 text-center"
}
const _hoisted_36 = { class: "sticky-header sticky-md-top mb-2" }
const _hoisted_37 = {
  id: "filesInMyDrive",
  class: "d-inline-block mr-3 mb-0"
}
const _hoisted_38 = {
  key: 0,
  class: "d-inline-block"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode()
const _hoisted_41 = { class: "hover-text" }
const _hoisted_42 = /*#__PURE__*/_createVNode("i", { class: "fa fa-share-alt" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode()
const _hoisted_44 = { class: "hover-text" }
const _hoisted_45 = {
  key: 5,
  class: "table-loader chat-load"
}
const _hoisted_46 = {
  key: 7,
  class: "empty-channel bg-white p-3 mb-3 text-center"
}
const _hoisted_47 = { class: "modal-wrap default-modal" }
const _hoisted_48 = {
  class: "modal fade",
  id: "detailModal",
  tabindex: "-1",
  "aria-labelledby": "detailModalLabel",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = { class: "modal-header" }
const _hoisted_52 = { class: "iconed-block-list" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "icon-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-folder" })
], -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-body\"><div class=\"ck-file-details\"><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Type</p></div><div class=\"col-sm-9 px-md-1\"><p>Folder</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Size</p></div><div class=\"col-sm-9 px-md-1\"><p>35.48 MB</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Owner</p></div><div class=\"col-sm-9 px-md-1\"><p>Me</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Shared with</p></div><div class=\"col-sm-9 px-md-1\"><div class=\"user-avatar xs\"><img src=\"https://lh3.googleusercontent.com/a-/AOh14Gg6GsVjMGcxlUEiwds4XFTfTXUSZ1DXJ6JP3G2PLg=s96-c\" alt=\"\"></div><div class=\"user-avatar xs\"><img src=\"https://lh3.googleusercontent.com/a-/AOh14Gg6GsVjMGcxlUEiwds4XFTfTXUSZ1DXJ6JP3G2PLg=s96-c\" alt=\"\"></div><div class=\"user-avatar xs\"><img src=\"https://lh3.googleusercontent.com/a-/AOh14Gg6GsVjMGcxlUEiwds4XFTfTXUSZ1DXJ6JP3G2PLg=s96-c\" alt=\"\"></div></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Modified</p></div><div class=\"col-sm-9 px-md-1\"><p>Feb 19, 2020 by Abu Bit Istiyak</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Opened</p></div><div class=\"col-sm-9 px-md-1\"><p>Apr 23, 2020 by Me</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Created</p></div><div class=\"col-sm-9 px-md-1\"><p>Feb 19, 2020</p></div></div></div></div>", 1)
const _hoisted_56 = { class: "modal-footer" }
const _hoisted_57 = {
  type: "button",
  class: "btn default-btn"
}
const _hoisted_58 = {
  type: "button",
  class: "btn secondary-btn"
}
const _hoisted_59 = { class: "modal-wrap default-modal" }
const _hoisted_60 = {
  class: "modal fade",
  id: "copyModal",
  tabindex: "-1",
  "aria-labelledby": "copyModalLabel",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><p class=\"text-success\"><i class=\"far fa-check-circle mr-2\"></i><strong>Link copied.</strong> Allows viewing. </p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"https://www.dropbox.com/s/11ydxpibqs2c5cr/01-Homepage-01.jpg?dl=0\"></div></div>", 2)
const _hoisted_65 = { class: "modal-footer" }
const _hoisted_66 = {
  type: "button",
  class: "btn default-btn"
}
const _hoisted_67 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_68 = { class: "modal-wrap default-modal" }
const _hoisted_69 = {
  class: "modal fade",
  id: "renameModal",
  tabindex: "-1",
  "aria-labelledby": "renameModalLabel",
  "aria-hidden": "true"
}
const _hoisted_70 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_71 = { class: "modal-content" }
const _hoisted_72 = { class: "modal-header" }
const _hoisted_73 = {
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "https://www.dropbox.com/s/11ydxpibqs2c5cr/01-Homepage-01.jpg?dl=0"
    })
  ])
], -1)
const _hoisted_76 = { class: "modal-footer" }
const _hoisted_77 = {
  type: "button",
  class: "btn default-btn"
}
const _hoisted_78 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_79 = { class: "modal-wrap default-modal" }
const _hoisted_80 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_81 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_82 = { class: "modal-content" }
const _hoisted_83 = { class: "modal-header" }
const _hoisted_84 = {
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_85 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_86 = { class: "modal-body" }
const _hoisted_87 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_88 = { class: "modal-footer" }
const _hoisted_89 = {
  type: "button",
  class: "btn default-btn"
}
const _hoisted_90 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_91 = { class: "modal-wrap default-modal" }
const _hoisted_92 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createFolder",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_93 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_94 = { class: "modal-content" }
const _hoisted_95 = { class: "modal-header" }
const _hoisted_96 = { class: "d-block" }
const _hoisted_97 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_98 = { class: "text-muted" }
const _hoisted_99 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_100 = { class: "modal-body" }
const _hoisted_101 = { class: "form-wrap pt-0" }
const _hoisted_102 = { class: "form-group" }
const _hoisted_103 = { for: "exampleInputEmail1" }
const _hoisted_104 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_MyDriveFileSearch = _resolveComponent("MyDriveFileSearch")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_MyDriveFilesUpload = _resolveComponent("MyDriveFilesUpload")
  const _component_MyDriveFolder = _resolveComponent("MyDriveFolder")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_MyDriveFile = _resolveComponent("MyDriveFile")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ShareModal = _resolveComponent("ShareModal")
  const _component_DeleteSelectedModal = _resolveComponent("DeleteSelectedModal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.getFolderList,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('upload_files')), 1),
          _createVNode("p", null, [
            _createVNode("small", null, _toDisplayString(_ctx.$t('get_storage')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("button", {
              id: "createFolderMyDrive",
              class: "btn default-btn outline d-inline-block mr-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCreateFolder && _ctx.showCreateFolder(...args)))
            }, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('create_folder')), 1)
            ]),
            _createVNode("label", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')) + " ", 1),
              _createVNode("input", {
                type: "file",
                id: "create-document-upload",
                multiple: "",
                accept: "*.*",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDocumentChange($event))),
                class: "d-none"
              }, null, 32)
            ]),
            _createVNode("button", {
              id: "fileTagSettings",
              class: "btn default-btn outline d-inline-block",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToFileTagSettings && _ctx.redirectToFileTagSettings(...args)))
            }, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('file_tag_settings')), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_MyDriveFileSearch, {
            id: "myDriveFileSearchByText",
            onFolderList: _ctx.searchFolderList,
            onErrorList: _ctx.searchErrorList,
            onHasError: _ctx.searchHasError,
            onSearchByTag: _ctx.searchByTag
          }, null, 8, ["onFolderList", "onErrorList", "onHasError", "onSearchByTag"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.selectedFileName = $event)),
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.saveFileName && _ctx.saveFileName(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.state.data.selectedFileName]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveFileName && _ctx.saveFileName(...args)))
              }, "Save changes")
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.selectedFolders && _ctx.state.data.selectedFolders.length)
      ? (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString(_ctx.state.data.selectedFolders), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_DragAndDropZone, {
      onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
      onDropFiles: _ctx.dropFiles
    }, null, 8, ["onDrop", "onDropFiles"]),
    (_ctx.imagesToUpload && _ctx.imagesToUpload.length)
      ? (_openBlock(), _createBlock(_component_MyDriveFilesUpload, {
          key: 1,
          imageList: _ctx.imagesToUpload,
          onUploadImage: _ctx.getReadyImageListToUpload,
          onLatestEnabledTags: _ctx.latestEnabledTags,
          dataClass: 'col-sm-6 col-md-4 col-lg-4 col-xl-2 px-2 mb-2',
          onRemoveSelectedImage: _ctx.removeSelectedImage,
          onOpenModal: _ctx.openRenameModal
        }, null, 8, ["imageList", "onUploadImage", "onLatestEnabledTags", "onRemoveSelectedImage", "onOpenModal"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_22, [
      (_ctx.imagesToUpload && _ctx.imagesToUpload.length)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "btn default-btn d-inline-block",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
          }, [
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_files')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_24, [
      _createVNode("ul", null, [
        _createVNode("li", null, [
          _createVNode("h5", _hoisted_25, _toDisplayString(_ctx.$t('folder')), 1)
        ]),
        (_ctx.isSearchByTagShort)
          ? (_openBlock(), _createBlock("li", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.selectedStatus = $event)),
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.getFolderList && _ctx.getFolderList(...args)))
                }, [
                  _createVNode("option", _hoisted_29, _toDisplayString(_ctx.$t('active')), 1),
                  _createVNode("option", _hoisted_30, _toDisplayString(_ctx.$t('archived')), 1),
                  _createVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('hidden')), 1)
                ], 544), [
                  [_vModelSelect, _ctx.state.selectedStatus]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_32,
    (_ctx.state.ui.isLoading.getFolderList)
      ? (_openBlock(), _createBlock("div", _hoisted_33, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl
        ? `${_ctx.state.data.imageBaseUrl}img/chat-loading.gif`
        : 'img/chat-loading.gif'
        ,
            alt: ""
          }, null, 8, ["src"])
        ]))
      : (_ctx.state.data.folderList &&
      _ctx.state.data.folderList.folders &&
      _ctx.state.data.folderList.folders.length
    )
        ? (_openBlock(), _createBlock("div", _hoisted_34, [
            (_ctx.state.data.folderList &&
        _ctx.state.data.folderList.folders &&
        _ctx.state.data.folderList.folders.length
      )
              ? (_openBlock(), _createBlock(_component_MyDriveFolder, {
                  key: 0,
                  folders: _ctx.state.data.folderList.folders,
                  onRename: _ctx.closeRenameFolderModal,
                  onDelete: _ctx.deleteSelectedFolder,
                  onSelectedFolder: _ctx.checkedSelctedFolder
                }, null, 8, ["folders", "onRename", "onDelete", "onSelectedFolder"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_35, [
            _createVNode(_component_EmptyData, {
              title: _ctx.state.data.folderTitle,
              heading: _ctx.state.data.folderHeading
            }, null, 8, ["title", "heading"])
          ])),
    _createVNode("div", _hoisted_36, [
      _createVNode("h5", _hoisted_37, _toDisplayString(_ctx.$t('files')), 1),
      (_ctx.state.data.selectedFiles && _ctx.state.data.selectedFiles.length)
        ? (_openBlock(), _createBlock("span", _hoisted_38, [
            _createVNode("a", {
              class: "round-icon red-btn  mx-2 p-0",
              href: "javascript:void(0)",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showDeleteSelectedModal && _ctx.showDeleteSelectedModal(...args)))
            }, [
              _hoisted_39,
              _hoisted_40,
              _createVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('delete')), 1)
            ]),
            _createVNode("a", {
              class: "round-icon black-btn mx-2 p-0",
              href: "javascript:void(0)",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showShareModal && _ctx.showShareModal(...args)))
            }, [
              _hoisted_42,
              _hoisted_43,
              _createVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('share')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.ui.isLoading.getFolderList)
      ? (_openBlock(), _createBlock("div", _hoisted_45, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl
        ? `${_ctx.state.data.imageBaseUrl}img/chat-loading.gif`
        : 'img/chat-loading.gif'
        ,
            alt: ""
          }, null, 8, ["src"])
        ]))
      : (_ctx.state.data.folderList.files && _ctx.state.data.folderList.files.length)
        ? (_openBlock(), _createBlock(_component_MyDriveFile, {
            key: 6,
            files: _ctx.state.data.folderList.files,
            onRename: _ctx.closeRenameFileModal,
            onDeleteFile: _ctx.deleteSelectedFile,
            onSelectedFile: _ctx.checkedSelctedFile,
            onTagUpdate: _ctx.updateFileTag
          }, null, 8, ["files", "onRename", "onDeleteFile", "onSelectedFile", "onTagUpdate"]))
        : (_openBlock(), _createBlock("div", _hoisted_46, [
            _createVNode(_component_EmptyData, {
              title: _ctx.state.data.fileTitle,
              heading: _ctx.state.data.fileHeading
            }, null, 8, ["title", "heading"])
          ])),
    _createVNode("div", _hoisted_47, [
      _createVNode("div", _hoisted_48, [
        _createVNode("div", _hoisted_49, [
          _createVNode("div", _hoisted_50, [
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _hoisted_53,
                    _createVNode("h5", null, _toDisplayString(_ctx.$t('untitled_folder')), 1)
                  ])
                ])
              ]),
              _hoisted_54
            ]),
            _hoisted_55,
            _createVNode("div", _hoisted_56, [
              _createVNode("button", _hoisted_57, _toDisplayString(_ctx.$t('share')), 1),
              _createVNode("button", _hoisted_58, _toDisplayString(_ctx.$t('download')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_59, [
      _createVNode("div", _hoisted_60, [
        _createVNode("div", _hoisted_61, [
          _createVNode("div", _hoisted_62, [
            _hoisted_63,
            _createVNode("div", _hoisted_65, [
              _createVNode("button", _hoisted_66, _toDisplayString(_ctx.$t('copy')), 1),
              _createVNode("button", _hoisted_67, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_68, [
      _createVNode("div", _hoisted_69, [
        _createVNode("div", _hoisted_70, [
          _createVNode("div", _hoisted_71, [
            _createVNode("div", _hoisted_72, [
              _createVNode("h5", _hoisted_73, _toDisplayString(_ctx.$t('rename')), 1),
              _hoisted_74
            ]),
            _hoisted_75,
            _createVNode("div", _hoisted_76, [
              _createVNode("button", _hoisted_77, _toDisplayString(_ctx.$t('save_changes')), 1),
              _createVNode("button", _hoisted_78, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_79, [
      _createVNode("div", _hoisted_80, [
        _createVNode("div", _hoisted_81, [
          _createVNode("div", _hoisted_82, [
            _createVNode("div", _hoisted_83, [
              _createVNode("h5", _hoisted_84, _toDisplayString(_ctx.$t('delete')), 1),
              _hoisted_85
            ]),
            _createVNode("div", _hoisted_86, [
              _createVNode("div", _hoisted_87, _toDisplayString(_ctx.$t('confirmation_delete')) + ". ", 1)
            ]),
            _createVNode("div", _hoisted_88, [
              _createVNode("button", _hoisted_89, _toDisplayString(_ctx.$t('ok')), 1),
              _createVNode("button", _hoisted_90, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_91, [
      _createVNode("div", _hoisted_92, [
        _createVNode("div", _hoisted_93, [
          _createVNode("div", _hoisted_94, [
            _createVNode("div", _hoisted_95, [
              _createVNode("div", _hoisted_96, [
                _createVNode("h5", _hoisted_97, _toDisplayString(_ctx.$t('create_folder')), 1),
                _createVNode("p", _hoisted_98, _toDisplayString(_ctx.$t('folders_description')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.hideCreateFolder && _ctx.hideCreateFolder(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_99
              ])
            ]),
            _createVNode("div", _hoisted_100, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.createNewFolder,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_101, [
                _createVNode("div", _hoisted_102, [
                  _createVNode("label", _hoisted_103, _toDisplayString(_ctx.$t('folder_name_label')), 1),
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "exampleInputFolderName",
                    "aria-describedby": "emailHelp",
                    placeholder: "eg.Team",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.data.folderName = $event)),
                    onKeydown: _cache[14] || (_cache[14] = _withKeys(
//@ts-ignore
(...args) => (_ctx.createNewFolder && _ctx.createNewFolder(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.state.data.folderName]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_104, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.createNewFolder && _ctx.createNewFolder(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.createNewFolder
                    ? _ctx.$t('creating_folder')
                    : _ctx.$t('create_folder')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 8,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showShareModal)
      ? (_openBlock(), _createBlock(_component_ShareModal, {
          key: 9,
          showModal: _ctx.state.data.showShareModal,
          selectedFiles: _ctx.state.data.selectedFiles,
          onClose: _ctx.closeShareModal
        }, null, 8, ["showModal", "selectedFiles", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDeleteModal)
      ? (_openBlock(), _createBlock(_component_DeleteSelectedModal, {
          key: 10,
          onClose: _ctx.closeDeleteMultipleModal,
          showModal: _ctx.state.data.showDeleteModal,
          selectedFiles: _ctx.state.data.selectedFiles
        }, null, 8, ["onClose", "showModal", "selectedFiles"]))
      : _createCommentVNode("", true)
  ]))
}